import { useState } from 'react'
import VerifyShopModal from '../admin/VerifyShopModal'
import RejectShopModal from '../admin/RejectShopModal'
import { VERIFICATION_STATUSES } from '../../constants/verificationStatuses'

const ApproveRejectActions = ({ shop, id }) => {
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [showRejectModal, setShowRejectModal] = useState(false)

  return (
    <div className="flex gap-4 mt-6">
      {shop.status !== VERIFICATION_STATUSES.approved.value && (
        <button
          onClick={() => setShowApproveModal(true)}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Approve
        </button>
      )}
      {shop.status !== VERIFICATION_STATUSES.rejected.value && (
        <button
          onClick={() => setShowRejectModal(true)}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
        >
          Reject
        </button>
      )}

      <VerifyShopModal
        isOpen={showApproveModal}
        onClose={() => setShowApproveModal(false)}
        shopName={shop?.shopName}
        shopId={shop?.shopId}
        id={id}
      />

      <RejectShopModal
        isOpen={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        shopName={shop?.shopName}
        shopId={shop?.shopId}
        id={id}
      />
    </div>
  )
}

export default ApproveRejectActions
